import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import PageHeader from "../components/PageHeader";

export default function PlaceholderPage({
  eyebrow,
  title,
  description,
  backTo = "/",
  backLabel = "Torna alla Home",
  testId,
}) {
  return (
    <div className="px-5 sm:px-8 lg:px-12 py-20 max-w-4xl mx-auto">
      <Link
        to={backTo}
        data-testid="placeholder-back-link"
        className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-white/40 hover:text-white/80 transition mb-10"
      >
        <ChevronLeft className="w-3.5 h-3.5" />
        {backLabel}
      </Link>

      <PageHeader
        eyebrow={eyebrow}
        title={title}
        description={description}
        testId={testId ? `${testId}-header` : undefined}
      />

      <div
        data-testid={testId || "placeholder-body"}
        className="glass-card p-10 sm:p-12"
      >
        <div className="text-[11px] tracking-[0.32em] uppercase text-emerald-400/70 mb-4">
          In arrivo
        </div>
        <p className="text-white/60 font-light leading-relaxed">
          Questa pagina è un segnaposto. I contenuti definitivi verranno
          pubblicati non appena la sezione sarà pronta.
        </p>
      </div>
    </div>
  );
}
